module.exports = {
  // The repo name for your Prismic repository (found in the url of your repo: https://your-repo-name.prismic.io/)
  prismicRepo: "20scoops-vc",
  secondPrismicRepo: "20-it",

  // Language configuration in your Prismic repository: Settings / Translations & locals
  defaultLanguage: "de-de",
  langs: ["de-de", "en-us"],
}
